import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, signal } from "@angular/core";
import { FUNCTION_RESULT_STATUS } from "@nova/common-interfaces";
import { ICustomerOverview, IServicePlan } from "@rfm/shared-interfaces";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { CommonComponent } from "../../../../lib/components/index.mjs";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { CustomerService } from "../../../shared/services/customers/customers.service.mjs";
import { ServicePlanService } from "../../../shared/services/products/service-plan.service.mjs";
//import { CommonComponent } from '@nova/common-client-side';
import { getAuth } from "@angular/fire/auth";
import { ActivatedRoute, Router } from "@angular/router";
import { PanelModule } from "primeng/panel";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { environment } from "../../../../environments/environment";
import { AccountInformationComponent } from "./account-information/account-information.component";
import { BillingInformationComponent } from "./billing-information/billing-information.component";
import { SubscriptionInformationComponent } from "./subscription-information/subscription-information.component";

@Component({
  selector: "app-overview",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    ProgressSpinnerModule,
    CardModule,
    PanelModule,
    BillingInformationComponent,
    AccountInformationComponent,
    SubscriptionInformationComponent,
  ],
  templateUrl: "./overview.component.html",
  styleUrl: "./overview.component.scss",
})
export class OverviewComponent extends CommonComponent implements OnInit {
  isLoggedIn = false;
  hasSubscriptions = false;
  myLoading = true;

  @Input()
  public customer_overview = signal<ICustomerOverview | undefined>(undefined);
  
  public plan: IServicePlan | undefined;

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private customerService: CustomerService,
    protected servicePlanService: ServicePlanService,
    private router: Router
  ) {
    super();
    this.isLoading(true);
    this.isLoading$.subscribe((state) => {
      this.myLoading = state;
    });

    this.authService.isLoggedIn$.subscribe((state) => {
      let uid = getAuth().currentUser!.uid;
      
      if (this.activatedRoute.snapshot.params['id'])
      {
        uid = this.activatedRoute.snapshot.params['id'];
      }

      this.isLoggedIn = state;
      if (state === false) {
        this.customer_overview.set(undefined);
        this.hasSubscriptions = false;
      } else {
        this.customerService
          .getOverview(uid!, true)
          .then(async (x) => {
            if (x.status === FUNCTION_RESULT_STATUS.SUCCESS) {
              this.customer_overview.set(x.data);

              if (!environment.production)
              {
                console.log("OVERVIEW RESULT", this.customer_overview());
              }
              
              if (
                this.customer_overview() &&
                this.customer_overview()?.subscriptions &&
                this.customer_overview()?.subscriptions?.data &&
                this.customer_overview()?.subscriptions?.data.length! > 0
              ) {
                this.hasSubscriptions = true;
                await this.servicePlanService
                  .get(
                    this.customer_overview()?.subscriptions!.data[0].plan?.id!
                  )
                  .then((x) => {
                    this.plan = x.data;
                  });
              }
            }
          })
          .finally(() => {
            console.log("Setting false");
            this.isLoading(false);
          });
      }
    });
  }

  ngOnInit(): void {}

  downloadInvoice() {
    this.router.navigateByUrl("/billing/invoices");
  }
}
